import { createFileRoute } from "@tanstack/react-router";
import ExistingPatients from "@/pages/ExistingPatients";
export const Route = createFileRoute("/existing-patients")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Existing Patients: Benefits Check & Scheduling | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Already a Neuro Wellness patient? Request a complimentary benefits check and let us schedule your next visit or start your treatment course.",
        },
        {
          property: "og:title",
          content:
            "Existing Patients: Benefits Check & Scheduling | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Already a Neuro Wellness patient? Request a complimentary benefits check and let us schedule your next visit or start your treatment course.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/existing-patients",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/existing-patients",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ExistingPatients />;
}
